import React from "react";
import XMassMaze from "../../XMassMaze";

const Screen46 = () => {
    return <XMassMaze />;
};

export default Screen46;
